import { action, isObservableMap, keys as keysMobx, reaction, values as valuesMobx } from 'mobx';
export * from './decorators/customComputed';
export function whenReaction(tracked, effect, options = {}) {
    return reaction(tracked, action(isTrue => {
        if (isTrue) {
            effect();
        }
    }), { fireImmediately: true, ...options });
}
export function universalMapKeys(map) {
    if (isObservableMap(map))
        return keysMobx(map);
    return Array.from(map.keys());
}
export function universalMapValues(map) {
    if (isObservableMap(map))
        return valuesMobx(map);
    return Array.from(map.values());
}
